module.exports = __webpack_public_path__ + "img/sd-b-c-1.35a9c024.jpg";